import { render, staticRenderFns } from "./LiveCalls.vue?vue&type=template&id=1dba02cd&"
import script from "./LiveCalls.vue?vue&type=script&lang=js&"
export * from "./LiveCalls.vue?vue&type=script&lang=js&"
import style0 from "./LiveCalls.vue?vue&type=style&index=0&id=1dba02cd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports